/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Terms_Cancel_1Inputs */

const da_terms_cancel_1 = /** @type {(inputs: Terms_Cancel_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Du kan opsige når som helst under Indstillinger → Abonnement → »Administrer betaling«. Opsigelsen gælder fra udløbet af den betalte periode. Der refunderes ikke for en påbegyndt periode.`)
};

/** @type {(inputs: Terms_Cancel_1Inputs) => LocalizedString} */
const en_terms_cancel_1 = da_terms_cancel_1;

/**

* @param {Terms_Cancel_1Inputs} inputs
* @param {{ locale?: "da" | "en" }} options
* @returns {LocalizedString}
*/
export const terms_cancel_1 = /** @type {((inputs?: Terms_Cancel_1Inputs, options?: { locale?: "da" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Terms_Cancel_1Inputs, { locale?: "da" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_terms_cancel_1(inputs)
	return /** @type {LocalizedString} */ ("Du kan opsige når som helst under Indstillinger → Abonnement → »Administrer betaling«. Opsigelsen gælder fra udløbet af den betalte periode. Der refunderes ikke for en påbegyndt periode.")
});